import React from 'react';

export const ChecklistVerifiedIcon = ({
  width = '16',
  height = '16',
  color = '#039855',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M14.6668 7.38527V7.99861C14.666 9.43622 14.2005 10.8351 13.3397 11.9865C12.4789 13.1379 11.269 13.9803 9.8904 14.3879C8.51178 14.7955 7.03834 14.7465 5.68981 14.2483C4.34128 13.7501 3.18993 12.8293 2.40747 11.6233C1.62501 10.4173 1.25336 8.99065 1.34795 7.55615C1.44254 6.12165 1.9983 4.75616 2.93235 3.66332C3.8664 2.57049 5.12869 1.80886 6.53096 1.49204C7.93323 1.17521 9.40034 1.32017 10.7135 1.90527M14.6668 2.66527L8.00017 9.33861L6.00017 7.33861"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
